import { ActionKeys } from './constants';

export interface DefaultPackageUnitsPayload {
  defaultDistanceUnit: string;
  defaultWeightUnit: string;
}

interface DefaultPackageUnitsErrorPayload {
  errorMessage: string;
}

export const fetchDefaultPackageUnits = () =>
  <const>{
    type: ActionKeys.FETCH_PACKAGE_DEFAULT_UNITS,
  };

export const fetchDefaultPackageUnitsSuccess = (payload: DefaultPackageUnitsPayload) =>
  <const>{
    payload,
    type: ActionKeys.FETCH_PACKAGE_DEFAULT_UNITS_SUCCESS,
  };

export const fetchDefaultPackageUnitsError = (payload: DefaultPackageUnitsErrorPayload) =>
  <const>{
    payload,
    type: ActionKeys.FETCH_PACKAGE_DEFAULT_UNITS_ERROR,
  };

export const updateDefaultPackageUnits = (payload: DefaultPackageUnitsPayload) =>
  <const>{
    payload,
    type: ActionKeys.UPDATE_PACKAGE_DEFAULT_UNITS,
  };

export const updateDefaultPackageUnitsSuccess = (payload: DefaultPackageUnitsPayload) =>
  <const>{
    payload,
    type: ActionKeys.UPDATE_PACKAGE_DEFAULT_UNITS_SUCCESS,
  };

export type PackagesActions =
  | ReturnType<typeof fetchDefaultPackageUnits>
  | ReturnType<typeof fetchDefaultPackageUnitsError>
  | ReturnType<typeof fetchDefaultPackageUnitsSuccess>
  | ReturnType<typeof updateDefaultPackageUnits>
  | ReturnType<typeof updateDefaultPackageUnitsSuccess>;
